import { render, staticRenderFns } from "./AfterSaleRepairList.vue?vue&type=template&id=7b4e9d51"
import script from "./AfterSaleRepairList.vue?vue&type=script&lang=js"
export * from "./AfterSaleRepairList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports